export const setBlacklist = function (state, payload) {
  state.blacklist = payload;
};

export const setNewItem = function (state, payload) {
  state.blacklist.push(payload);
};

export const updateItem = function (state, payload) {
  const array = state.blacklist;
  const id = payload.id;
  const index = array.findIndex((a) => a.id === id);
  array.splice(index, 1, payload);
};

export const deleteItem = function (state, payload) {
  const array = state.blacklist;
  const id = payload.id;
  const index = array.findIndex((a) => a.id === id);
  array.splice(index, 1);
};
